export default __webpack_public_path__ + "assets/capture-new.f07abcc2.png";